var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Map, Set } from "immutable";
import jwt_decode from "jwt-decode";
import moment from "moment";
import { maybe } from "tsmonads";
import { WebSocketMessage } from "./serverConnection";
var GlobalState = /** @class */ (function () {
    function GlobalState() {
        this.lastUpdate = moment.now();
        this.notifications = {};
        this.users = Map();
        this.devices = Map();
        this.videos = Map();
        this.orders = Map();
        this.products = Map();
        this.enterprises = Map();
        this.responses = Set();
    }
    return GlobalState;
}());
export { GlobalState };
export var appReducer = function (oldState, action) {
    var state = __assign({}, oldState);
    // tslint:disable-next-line: no-console
    console.log(action);
    switch (action.action) {
        case "error": {
            var error = action.error;
            // tslint:disable-next-line: no-console
            console.error("Server error: " + error);
            if (error.startsWith("Unknown session token") || error.startsWith("Invalid token")) {
                localStorage.removeItem("user");
                window.open("/", "_self", undefined, true);
                return new GlobalState();
            }
            else {
                var id = moment().unix();
                state.notifications[moment().unix()] = {
                    id: id,
                    type: "ERROR",
                    message: error
                };
            }
            break;
        }
        case "fromToken": {
            state.user = maybe(localStorage.getItem("user")).map(function (u) { return JSON.parse(u); }).orUndefined();
            if (state.user) {
                // tslint:disable-next-line: no-console
                console.warn("reinit for store queries");
                action.send(WebSocketMessage("ping", "update", {}, state.user.token));
            }
            break;
        }
        case "logout": {
            localStorage.removeItem("user");
            return new GlobalState();
        }
        case "update": {
            var _a = action.payload, data = _a.data, channel = _a.channel;
            switch (channel) {
                case "responses":
                    state.responses = state.responses.add(data);
                    break;
                case "notifications":
                    var id = moment().unix();
                    state.notifications[moment().unix()] = {
                        id: id,
                        type: data.type,
                        message: data.message
                    };
                    break;
                case "auth":
                    state.user = __assign(__assign({}, data), jwt_decode(data.token));
                    localStorage.setItem("user", JSON.stringify(state.user));
                    break;
                case "enterprises":
                    state.enterprises = state.enterprises.set(data.id, __assign(__assign({}, state.enterprises.get(data.id)), data));
                    break;
                case "devices":
                    state.devices = state.devices.set(data.id, __assign(__assign({}, state.devices.get(data.id)), data));
                    break;
                case "products":
                    state.products = state.products.set(data.id, __assign(__assign({}, state.products.get(data.id)), data));
                    break;
                case "orders":
                    state.orders = state.orders.set(data.id, __assign(__assign({}, state.orders.get(data.id)), data));
                    break;
                case "users":
                    state.users = state.users.set(data.id, __assign(__assign({}, state.users.get(data.id)), data));
                    break;
                case "videos":
                    state.videos = state.videos.set(data.id, __assign(__assign({}, state.videos.get(data.id)), data));
                    break;
            }
            break;
        }
        case "delete": {
            var _b = action.payload, id = _b.id, channel = _b.channel;
            switch (channel) {
                case "enterprises":
                    state.enterprises = state.enterprises.remove(id);
                    break;
                case "devices":
                    state.devices = state.devices.remove(id);
                    break;
                case "products":
                    state.products = state.products.remove(id);
                    break;
                case "orders":
                    state.orders = state.orders.remove(id);
                    break;
                case "users":
                    state.users = state.users.remove(id);
                    break;
                case "videos":
                    state.videos = state.videos.remove(id);
                    break;
                case "notifications":
                    delete state.notifications[id];
                    break;
            }
            break;
        }
        case "store": {
            var _c = action.payload, data = _c.data, channel = _c.channel;
            var dataSet_1 = {};
            data.forEach(function (d) { return dataSet_1[d.id] = d; });
            switch (channel) {
                case "enterprises":
                    state.enterprises = state.enterprises.merge(Map(dataSet_1));
                    break;
                case "products":
                    state.products = state.products.merge(Map(dataSet_1));
                    break;
                case "devices":
                    state.devices = state.devices.merge(Map(dataSet_1));
                    break;
                case "orders":
                    state.orders = state.orders.merge(Map(dataSet_1));
                    break;
                case "users":
                    state.users = state.users.merge(Map(dataSet_1));
                    break;
                case "videos":
                    state.videos = state.videos.merge(Map(dataSet_1));
                    break;
            }
            break;
        }
    }
    state.lastUpdate = moment.now();
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/state.ts
// module id = 1298
// module chunks = 0